// import { setToken } from '../../utils/auth.util';
// import { ApiPostNoAuth } from '../api'; 
// export function userSingIn(info) {

//     return new Promise(async (resolve, reject) => {
//         // console.log(info,"info");

//         try {
//             const res = await ApiPostNoAuth('user/login', info);
//             setToken(res?.data?.token)
//             resolve(res);
//         } catch (error) {
//             reject(error);
//         }
//     });
// }



import { setToken } from '../../utils/auth.util';
import { ApiPostNoAuth } from '../api'; // Adjust import path as needed
import { setUserInfo } from '../../utils/user.util'; // Adjust path if different

export function userSingIn(info) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await ApiPostNoAuth('user/login', info);

      // Save token to localStorage
      setToken(res?.data?.token);

      // Save user info to localStorage
      await setUserInfo(res?.data?.user);

      resolve(res);
    } catch (error) {
      reject(error);
    }
  });
}

